import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { Scrollbar } from '@app/components';
import { ProjectInfo } from './projectInfo';
import { useDialog, useRequestState } from '@app/hooks';
import { selectProjectDetailsState } from '../selector';
import { getProjectDetails } from '../slice';
import AddProject from '../view/add-project';
import { useAuthRole } from '@app/utils';

const ProjectDetailsPage = () => {
  const editDialog = useDialog();
  const { state } = useLocation();
  const projectId = state.id;
  const dispatch = useDispatch();

  useEffect(() => {
    if (projectId) {
      dispatch(getProjectDetails(projectId));
    }
  }, [projectId, dispatch]);
  const { data } = useRequestState({
    stateSelector: selectProjectDetailsState,
    errorShown: true,
  });
  const goBack = () => {
    history.back();
  };
  const { isManager, isSuperAdmin } = useAuthRole();

  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header
          goBack={goBack}
          title={Strings.page_title.details}
          helperText={''}
          actionButtonTitle={isManager || isSuperAdmin ? Strings.button.editProject : undefined}
          onClickActionButton={editDialog.show}
        />
      </Box>
      <Scrollbar>
        <ProjectInfo projectData={data} />
      </Scrollbar>
      {editDialog.visible && <AddProject row={data.project} open onClose={editDialog.hide} />}
    </>
  );
};
export { ProjectDetailsPage };
